import { useState } from "react";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Vsl } from "@/components/Vsl";
import { SpeedToLead } from "@/components/SpeedToLead";
import { Marquee } from "@/components/Marquee";
import { Checklist } from "@/components/Checklist";
import { LostLead } from "@/components/LostLead";
import { Calculator } from "@/components/Calculator";
import { Mechanism } from "@/components/Mechanism";
import { Proof } from "@/components/Proof";
import { OfferStack } from "@/components/OfferStack";
import { Comparison } from "@/components/Comparison";
import { Founder } from "@/components/Founder";
import { OrdinaryDay } from "@/components/OrdinaryDay";
import { Faq } from "@/components/Faq";
import { Booking } from "@/components/Booking";
import { Footer } from "@/components/Footer";
import { MobileCta } from "@/components/MobileCta";

export default function LandingPage() {
  const [calcInputs, setCalcInputs] = useState({
    leads: 180,
    caseValue: 8000,
    lostPct: 28,
    closeRate: 30,
  });

  return (
    <main className="bg-obsidian text-pearl" data-testid="landing-page">
      <Navbar />
      <Hero />
      <Vsl />
      <SpeedToLead />
      <Marquee />
      <Checklist />
      <LostLead />
      <Calculator inputs={calcInputs} setInputs={setCalcInputs} />
      <Mechanism />
      <Proof />
      <OfferStack />
      <Comparison />
      <Founder />
      <OrdinaryDay />
      <Faq />
      <Marquee
        reverse
        testid="layers-marquee"
        items={["Coverage", "Pipeline", "Follow-up and booking", "Financial visibility", "Account management"]}
      />
      <Booking />
      <Footer />
      <MobileCta />
    </main>
  );
}
